{
  "contactCustomerService": "聯繫客服",
  "close": "關閉",
  "notConfigured": "客服尚未設定",
  "temporarilyUnavailable": "客服暫時無法載入",
  "retry": "重試"
}
